import React from 'react';
import { NavLink } from 'react-router-dom';
import { ROUTE_PATHS } from '@constants';

const home = {
    key: ROUTE_PATHS.HOME,
    label: (
        <NavLink to={ROUTE_PATHS.HOME} data-e2e='header_home_tab'>
            Home
        </NavLink>
    )
};

export const BLOCKED_MENU_ITEMS = [home];

export const getMenuItemsWithHandlers = (onClick) => [
    home,
    {
        key: ROUTE_PATHS.PRODUCTS,
        label: (
            <NavLink to={ROUTE_PATHS.PRODUCTS} data-e2e='header_products_tab'>
                Products
            </NavLink>
        )
    },
    {
        key: ROUTE_PATHS.CAMPAIGNS,
        label: (
            <NavLink
                to={ROUTE_PATHS.CAMPAIGNS}
                onClick={(e) => onClick(e, ROUTE_PATHS.CAMPAIGNS)}
                data-e2e='header_campaigns_tab'
            >
                Campaigns
            </NavLink>
        )
    },
    {
        key: ROUTE_PATHS.ORDERS,
        label: (
            <NavLink to={ROUTE_PATHS.ORDERS} data-e2e='header_orders_tab'>
                Orders
            </NavLink>
        )
    },
    {
        key: ROUTE_PATHS.PERFORMANCE,
        label: (
            <NavLink to={ROUTE_PATHS.PERFORMANCE} data-e2e='header_performance_tab'>
                Performance
            </NavLink>
        )
    },
    {
        key: ROUTE_PATHS.INSIGHTS,
        label: (
            <NavLink to={ROUTE_PATHS.INSIGHTS} data-e2e='header_insights_tab'>
                Insights
            </NavLink>
        )
    },
    {
        key: ROUTE_PATHS.PERKS,
        label: (
            <NavLink to={ROUTE_PATHS.PERKS} data-e2e='header_perks_tab'>
                Perks
            </NavLink>
        )
    }
];
